module.exports = __webpack_public_path__ + "static/media/ice43.97cf3846.webp";